var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcJacuzzi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6162 1.3335H20.6315",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4243 7.26702C15.8339 7.26702 16.166 6.93497 16.166 6.52536C16.166 6.11575 15.8339 5.78369 15.4243 5.78369C15.0147 5.78369 14.6826 6.11575 14.6826 6.52536C14.6826 6.93497 15.0147 7.26702 15.4243 7.26702Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8413 8.75042C23.2509 8.75042 23.5829 8.41837 23.5829 8.00876C23.5829 7.59915 23.2509 7.26709 22.8413 7.26709C22.4317 7.26709 22.0996 7.59915 22.0996 8.00876C22.0996 8.41837 22.4317 8.75042 22.8413 8.75042Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 14.6835H10.233M10.233 14.6835V19.1335H17.6497V14.6835M10.233 14.6835C10.233 13.7935 10.8263 13.2002 11.7163 13.2002H16.1663C17.0563 13.2002 17.6497 13.7935 17.6497 14.6835M17.6497 14.6835H30.9997",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2998 14.6836V22.1003C4.2998 22.8871 4.61236 23.6417 5.16872 24.198C5.72508 24.7544 6.47966 25.0669 7.26647 25.0669H25.0665C25.8533 25.0669 26.6079 24.7544 27.1642 24.198C27.7206 23.6417 28.0331 22.8871 28.0331 22.1003V14.6836M8.7498 25.0669V28.0336M23.5831 25.0669V28.0336",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcJacuzzi);
export default __webpack_public_path__ + "static/media/ic_jacuzzi.340bef106635db4f3d4662c22f02c1ec.svg";
export { ForwardRef as ReactComponent };